import { useIntl } from "react-intl"

export function MidtownLogo({ className = "" }: { className?: string }) {
	const intl = useIntl()

	const midtownLogoAlt = intl.formatMessage({ id: "app.alt.midtown.logo", defaultMessage: "Midtown Athletic Club Logo" })

	return <img className={`w-48 mt-10 ${className}`} src="header-logo.svg" alt={midtownLogoAlt} />
}